var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('adviser-avatar',{class:_vm.b('avatar'),attrs:{"image":_vm.avatar}}),_c('div',{class:_vm.b('bubble')},[_c('beat-loader',{attrs:{"size":"12px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }